import { injectEmspBoEmspUserApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-emsp-user.service';

import { baseApi } from '@service/base-api.service';

export const emspBoEmspUserApi = injectEmspBoEmspUserApi(baseApi);

export const {
  useEmspBoGetEmspUsersQuery,
  useEmspBoGetEmspUserQuery,
  useLazyEmspBoGetEmspUserLockStatusQuery,
  useEmspBoLockEmspUserMutation,
  useEmspBoUnlockEmspUserMutation,
  useEmspBoCreateOcpiTokenForEmspUserMutation,
  useEmspBoDeleteOcpiTokenForEmspUserMutation,
  useEmspBoUpdateOcpiTokenForEmspUserMutation,
} = emspBoEmspUserApi;
